<div class="app-icon-container">
    <app-editable-image
        [elemId]="'b9ee34b0-45ea-457a-a024-3ad8a12338df'"
        [imageReference]="imageReference"
        [fileTypes]="supportedFileTypes"
        [maxWidth]="120"
        [maxHeight]="120"
        [customClass]="'app-icon-custom-class'"
        [forceEditMode]="true"
        ></app-editable-image> 
</div>